module.exports = __webpack_public_path__ + "9d318ed6cabee497d2d8a6e91e4f9a56.svg";